export default "__VITE_ASSET__BjHNN_Wi__"